jQuery(document).ready(function() {
  let fileUploads = jQuery('.gfield--type-fileupload');
  if (fileUploads.length) {
    fileUploads.each(function() {
      let fileUpload = jQuery(this).find('input[type="file"');
      let label = jQuery(this).find('label');

      fileUpload.on('change', function() {
        let fileName = fileUpload[0].files[0].name;
        label.html(fileName);
      });
    });
  }
});
